"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionWithBudget = void 0;
var _react = _interopRequireDefault(require("react"));
var _QuestionWithRange = _interopRequireDefault(require("./QuestionWithRange"));
var _useBudgetQuestion = require("../../hooks/questionnaire/useBudgetQuestion");
var _services = require("../../services");
var _constants = require("../../utils/constants");
var _QuestionWithMulti = _interopRequireDefault(require("./QuestionWithMulti"));
var _DynamicLoader = _interopRequireDefault(require("../CutomLoader/DynamicLoader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const QuestionWithBudget = _ref => {
  let {
    question,
    selections = []
  } = _ref;
  const {
    isBudgetReady,
    budgetQuestion,
    adjustBudget,
    defaultSelection
  } = (0, _useBudgetQuestion.useBudgetQuestion)(question);
  if (!isBudgetReady) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        margin: 'auto'
      },
      id: "no-budget-question",
      "data-test-id": "question-with-budget"
    }, /*#__PURE__*/_react.default.createElement(_DynamicLoader.default, {
      size: 1,
      srText: _services.locale.localeString('Questionnaire.LoaderText'),
      indicatorTestId: "budget-slider-loader"
    }));
  }
  const body = /*#__PURE__*/_react.default.createElement("div", {
    id: "budget-question",
    "data-test-id": "question-with-budget"
  }, (budgetQuestion === null || budgetQuestion === void 0 ? void 0 : budgetQuestion.type) === _constants.QUESTION_TYPE.MULTI ? /*#__PURE__*/_react.default.createElement(_QuestionWithMulti.default, {
    question: budgetQuestion,
    selections: selections,
    onUpdate: adjustBudget
  }) : /*#__PURE__*/_react.default.createElement(_QuestionWithRange.default, {
    question: budgetQuestion,
    selections: selections,
    onUpdate: adjustBudget,
    defaultSelection: defaultSelection
  }));
  return body;
};
exports.QuestionWithBudget = QuestionWithBudget;